import React from 'react';
import PropTypes from 'prop-types';
import { InputContainer } from '../Form/FormElements.styles';
import { tags } from '../../OnlineTraining/Tags';

const SelectIndustry = ({
  value,
  nestedValue,
  upperValue,
  containerClassName,
}) => {
  const industryOptions = tags.filter((tag) => tag.id !== 'all');

  const handleChange = (e) => {
    const selectedValue = e.target.value;
    nestedValue({
      ...upperValue,
      industry: selectedValue,
    });
  };

  return (
    <InputContainer className={containerClassName}>
      <select id="industry" value={value || ''} onChange={handleChange}>
        <option value="" disabled>
          -- Select an Industry --
        </option>
        {industryOptions.map((option) => (
          <option key={option.id} value={option.id}>
            {option.label}
          </option>
        ))}
      </select>
      <label htmlFor="industry">Select Industry:</label>
    </InputContainer>
  );
};

SelectIndustry.propTypes = {
  value: PropTypes.string,
  nestedValue: PropTypes.func,
  upperValue: PropTypes.object,
  containerClassName: PropTypes.string,
};

export default SelectIndustry;
